import { type FC, Suspense } from 'react';

import { RemoteModuleErrorBoundary } from '../CustomerManagement/RemoteModuleErrorBoundary';
import { SimplifiedCardModule } from '../CustomerManagement/SimplifiedCardModule';
import { HiddenContainer } from './CustomerCardPreloader.styles';
import { useCustomerCardPreloader } from './useCustomerCardPreloader';

export const CustomerCardPreloader: FC = () => {
    const { commonConsumerId, environment, status, readyRef, handleError } = useCustomerCardPreloader();

    if (!commonConsumerId) return null;

    return (
        <HiddenContainer aria-hidden data-testid="customer-card-preloader" data-status={status}>
            <RemoteModuleErrorBoundary
                moduleName="SimplifiedCardModule"
                commonConsumerId={commonConsumerId}
                fallback={null}
                onError={handleError}
            >
                <Suspense fallback={null}>
                    <SimplifiedCardModule commonConsumerID={commonConsumerId} environment={environment} editCapability="hidden" />
                    <span ref={readyRef} style={{ display: 'none' }} />
                </Suspense>
            </RemoteModuleErrorBoundary>
        </HiddenContainer>
    );
};
